import Joi from "joi";
import { customMessages } from "./messages";

function ValidateResponsible(responsible) {
  const schema = Joi.object({
    nome: Joi.string().min(3).max(100).required().messages(customMessages.nome),
    cpf: Joi.string().min(11).max(14).required().messages(customMessages.cpf),
    endereco: Joi.string().min(3).max(100).required().messages(customMessages.endereco),
    bairro: Joi.string().min(3).max(100).required().messages(customMessages.bairro),
    numero: Joi.string().max(10).required().messages(customMessages.numero),
    cidade: Joi.string().min(3).max(100).required().messages(customMessages.cidade),
    uf: Joi.string().min(2).max(2).required().messages(customMessages.uf),
    cep: Joi.string().min(8).max(9).required().messages(customMessages.cep),
    receita: Joi.number().positive().required().messages(customMessages.receitasart),
    quantidadeReceita: Joi.number().positive().required().messages(customMessages.quantidadereceita),
    art: Joi.string().max(100).required().messages(customMessages.artatual),
  }).unknown(true)

  const { error } = schema.validate(responsible, { abortEarly: false })
 
  if(error?.details && error?.details.length) {
    const errors = error?.details.map(erro => {
      if (erro?.message || erro?.path[0]) {
        if(erro.path.length > 1) {
          return {
            message: erro?.message,
            keyError: erro?.path[1],
            type: erro.type.split('.')[1]
          }
        }
        
        return {
          message: erro?.message,
          keyError: erro?.path[0],
          type: erro.type.split('.')[1]
        }
      }
    })

    return errors
  }
}

export { ValidateResponsible }